import { aiPredictionGradient } from '../../theme';

export const aiAssistantColors = {
  background: aiPredictionGradient.backgroundDiagonal,
};
